var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#528AEA",
    fillRule: "nonzero",
    transfrom: "rotate(180deg)",
    d: "M.36 7.766h2.856V12h4.288V7.766h2.856l-5-4.941-5 4.94zm10-6.354V0h-10v1.412h10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBlue);
export default __webpack_public_path__ + "static/media/upload-blue.f7474a9169b295a6568acc213cb29fd6.svg";
export { ForwardRef as ReactComponent };